import { catOf, UNSORTED } from "./usePhotoCategories";

export function PhotoFilters({ photos, categories, category, setCategory, uploader, setUploader }) {
  const counts = photos.reduce((m, p) => { const c = catOf(p, categories); m[c] = (m[c] || 0) + 1; return m; }, {});
  const people = [...new Map(photos.map((p) => [p.uploaded_by_id, p.uploaded_by_name])).entries()].filter(([id]) => id);
  const chip = (key, label, n) => (
    <button key={key} type="button" onClick={() => setCategory(key)} aria-pressed={category === key} data-testid={`photo-filter-${key.toLowerCase().replace(/\s+/g, "-")}`}
      className={`h-8 px-3 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${category === key ? "bg-[#18181b] text-[#fff] dark:bg-[#fff] dark:text-[#18181b]" : "bg-zinc-100 text-zinc-700 hover:bg-zinc-200 dark:bg-white/5 dark:text-zinc-300 dark:hover:bg-white/10"} ${key === UNSORTED && n ? "ring-1 ring-amber-400" : ""}`}>
      {label}<span className="ml-1.5 opacity-60">{n}</span>
    </button>
  );
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="photo-filters">
      <div className="flex gap-1.5 overflow-x-auto pb-0.5 max-w-full">
        {chip("all", "All", photos.length)}
        {counts[UNSORTED] > 0 && chip(UNSORTED, "Unsorted", counts[UNSORTED])}
        {categories.filter((c) => counts[c]).map((c) => chip(c, c, counts[c]))}
      </div>
      {people.length > 1 && (
        <select value={uploader} onChange={(e) => setUploader(e.target.value)} aria-label="Filter by uploader" data-testid="photo-filter-uploader"
          className="h-8 rounded-full border border-zinc-200 dark:border-white/10 bg-background px-3 text-xs">
          <option value="all">Everyone</option>
          {people.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
        </select>
      )}
    </div>
  );
}
